import { TransactionReportViewModel, UserTerminalInfo } from "@payping/api";
import { CLEAR_LIST, LOGGED_OUT } from "./constants";
import { ClearListAction, LoggedOutAction } from "./types";
import { TransactionDetailsVM } from "../actions";

export const REPORTS_LOADED = "REPORTS_LOADED";
export const SET_REPORT_DETAILS = "SET_REPORT_DETAILS";
export const SET_TRANSACTION_ISPAID = "SET_TRANSACTION_ISPAID";
export const SET_TOTAL_TRANSACTION_COUNT = "SET_TOTAL_TRANSACTION_COUNT";
export const SET_USER_TERMINAL_LIST = "SET_USER_TERMINAL_LIST";

export interface ReportState {
  list: TransactionReportViewModel[];
  totalCount: number;
  paginationEnd: boolean;
  details?: TransactionDetailsVM;
  totalTransactionCount?: number;
  terminalList: UserTerminalInfo[];
}

export interface ReportsLoadedAction {
  type: typeof REPORTS_LOADED;
  payload: { list: TransactionReportViewModel[]; totalCount: number; append: boolean };
}

export interface SetReportDetailsAction {
  type: typeof SET_REPORT_DETAILS;
  payload: { details?: TransactionDetailsVM };
}

export interface SetTransactionIsPaidAction {
  type: typeof SET_TRANSACTION_ISPAID;
  payload: { code: string };
}

export interface SetTotalTransactionCountAction {
  type: typeof SET_TOTAL_TRANSACTION_COUNT;
  payload: number;
}

export interface SetUserTerminalList {
  type: typeof SET_USER_TERMINAL_LIST;
  payload: UserTerminalInfo[];
}

export type ReportActionTypes =
  | ReportsLoadedAction
  | SetReportDetailsAction
  | SetTransactionIsPaidAction
  | SetTotalTransactionCountAction
  | SetUserTerminalList
  | ClearListAction
  | LoggedOutAction;

const initialState: ReportState = {
  details: undefined,
  list: [],
  paginationEnd: false,
  terminalList: [],
  totalCount: 0,
  totalTransactionCount: 0,
};

export default function reports(state = initialState, action: ReportActionTypes): ReportState {
  if (action.type === REPORTS_LOADED) {
    const { list, totalCount, append } = action.payload;
    const newList = append ? [...state.list, ...list] : list;
    return {
      ...state,
      list: newList,
      paginationEnd: !list.length || newList.length >= totalCount,
      totalCount,
    };
  }

  if (action.type === SET_REPORT_DETAILS) {
    const { details } = action.payload;
    return {
      ...state,
      details,
    };
  }

  if (action.type === SET_TRANSACTION_ISPAID) {
    const { code } = action.payload;
    const list = state.list.map((report) => (report.code === code ? { ...report, isPaid: true } : report));
    const details = state.details ? { ...state.details, isPaid: true } : undefined;
    return {
      ...state,
      details,
      list,
    };
  }

  if (action.type === SET_TOTAL_TRANSACTION_COUNT) {
    return {
      ...state,
      totalTransactionCount: action.payload,
    };
  }

  if (action.type === SET_USER_TERMINAL_LIST) {
    return {
      ...state,
      terminalList: action.payload,
    };
  }

  if (action.type === CLEAR_LIST) {
    return {
      ...state,
      list: [],
    };
  }

  if (action.type === LOGGED_OUT) {
    return initialState;
  }

  return state;
}
